import { Button, Trans } from '../../atoms'
import CartAlerts from '../../organisms/CartAlerts/CartAlerts'
import ArticoliPersonalizzati from '../ArticoliPersonalizzati/ArticoliPersonalizzati'
import ArticoliSenzaStampa from '../ArticoliSenzaStampa/ArticoliSenzaStampa'
import useTrans from '../../../hooks/useTrans'
import Link from 'next/link'
import { Bin, Plus } from '../../atoms/NewIcons'
import { useSelector } from 'react-redux'

const ArticoliCarrello = ({
  carrelloMain,
  checkErroriCarrello,
  setId,
  setCodice,
  setOpenModalQuantita,
  MoveToLater,
  Delete,
  setOpenModalNota,
  setNota,
  setOpenNomeLavorazioneModal,
  setNomeLavorazione,
  setOpenModalRimuovi,
  MoveToMainPersonalizzazione,
  EliminaPersonalizzazione,
  MoveToLaterPersonalizzazione,
  SvuotaCarrelloMain,
}) => {
  const t = useTrans()
  const { service_gift } = useSelector((state) => state.servicegift)

  return (
    <div className="articoli__carrello">
      <div className="articoli__carrello__head">
        <div className="articoli__carrello__top-buttons">
          <Link href="/strumenti-servizi/ordine-veloce/">
            <Button
              className="articoli__carrello__button-import"
              icon={<Plus />}
              icon_pos="left"
              label={t('Inserisci ordine tramite Excel')}
              variant="ghost"
              size="large"
              responsive
            />
          </Link>
          {carrelloMain && carrelloMain.numero_righe > 0 && (
            <Button
              className="articoli__carrello__button-svuota"
              icon={<Bin />}
              icon_pos="left"
              label={t('Svuota carrello')}
              variant="ghost"
              size="large"
              responsive
              onClick={() => SvuotaCarrelloMain()}
            />
          )}
        </div>
        <p className="articoli__carrello__title">
          <Trans chiave="Articoli in carrello" /> ({carrelloMain ? carrelloMain.numero_righe : 0})
        </p>
      </div>
      {carrelloMain && carrelloMain.numero_righe > 0 && (
        <>
          <div className="articoli__carrello__alerts">
            <CartAlerts
              checkErroriCarrello={checkErroriCarrello}
              errori={carrelloMain?.errori}
              setId={setId}
              saveCodice={setCodice}
              setOpenModalQuantita={setOpenModalQuantita}
            />
          </div>

          {carrelloMain?.righe_carrello_merce_neutra.length > 0 && (
            <div className="articoli__carrello__block">
              <div className="articoli__carrello__block-head">
                {(!service_gift || service_gift?.personalizzazione) && (
                <p className="articoli__carrello__subtitle">
                  <Trans chiave="Articoli non personalizzati" />
                </p>
                )}
              </div>
              <ArticoliSenzaStampa
                carrelloMain={carrelloMain}
                righe={
                  carrelloMain?.righe_carrello_merce_neutra
                    ? carrelloMain?.righe_carrello_merce_neutra
                    : []
                }
                MoveToLater={MoveToLater}
                Delete={Delete}
                setOpenModalNota={setOpenModalNota}
                setId={setId}
                setNota={setNota}
                setCodice={setCodice}
                setOpenModalRimuovi={setOpenModalRimuovi}
                setOpenModalQuantita={setOpenModalQuantita}
              />
            </div>
          )}

          {carrelloMain?.personalizzazioni_carrello.length > 0 && (
            !service_gift || service_gift?.personalizzazione ) && (
              <ArticoliPersonalizzati
                carrelloMain={carrelloMain}
                righe={
                  carrelloMain?.personalizzazioni_carrello
                    ? carrelloMain.personalizzazioni_carrello
                    : []
                }
                MoveToMainPersonalizzazione={MoveToMainPersonalizzazione}
                MoveToLaterPersonalizzazione={MoveToLaterPersonalizzazione}
                MoveToLater={MoveToLater}
                Delete={Delete}
                setOpenModalNota={setOpenModalNota}
                setId={setId}
                setCodice={setCodice}
                setNota={setNota}
                setOpenNomeLavorazioneModal={setOpenNomeLavorazioneModal}
                setNomeLavorazione={setNomeLavorazione}
                setOpenModalRimuovi={setOpenModalRimuovi}
                setOpenModalQuantita={setOpenModalQuantita}
                EliminaPersonalizzazione={EliminaPersonalizzazione}
              />
          )}
        </>
      )}
    </div>
  )
}
export default ArticoliCarrello
